<template>
  <div class="popup" v-cloak v-if="shareShow">
    <!--    <div class="content" id="share" v-bind:class="[inviteEmailShow&&clickCurrent!==0?shareEmail:'',linkCreatedShow&&emailClassShow?shareEmailLink:'',linkCreatedShow&&!emailClassShow?shareLink:'',clickCurrent===0&&!inviteEmailShow?shareCommunity:'', clickCurrent===0&&inviteEmailShow?'share-community-email':'']">-->
    <div class="content" id="share" :class="classesOfDialog" :style="inviteEmailShow?{height:emailHeight}:''">
      <div class="title">
        <!-- <span v-if="!notSupportSourceShow">{{$t('language.popup.cloudExploerPopup.shareWithOthers')}}</span>
        <span v-if="notSupportSourceShow">{{$t('language.common.attention')}}</span> -->
        <span>{{$t('language.popup.cloudExploerPopup.shareWithOthers')}}</span>
        <div class="icon white-close dialog-close" @click="closeDialog"></div>
      </div>
      <!--      <div class="share-content" id="shareContent" v-bind:class="[inviteEmailShow?shareContentEmail:'',linkCreatedShow&&emailClassShow?shareContentEmailLink:'',linkCreatedShow&&!emailClassShow?shareContentLink:'']">-->
      <div class="share-content" id="shareContent" v-if="!inviteEmailShow" >
        <!-- <div class="share-item" :key="index" v-for="(shareItem,index) in sharetypes"  v-if="!(index===3&&!judgeSourceCloud)"
             :class="[index===clickCurrent?'share-item-checked':'', clickCurrent===0&&index===clickCurrent?'share-community-content':'']"> -->
        <div class="share-item share-item-checked" :style="index==3?'margin-bottom: 15px':''" :key="index" v-for="(shareItem,index) in sharetypes"  v-show="index==1||index==2||(index===3&&judgeSourceCloud)">
          <div :class="[linkCreatedShow==true?'share-forbidden':loading?'share-forbidden':'']">
            <div class="item-title">
              <div class="icon-util radio radio-position" :class="[index==clickCurrent?linkCreatedShow?'check-radio-disable':loading?'check-radio-disable':'check-radio':linkCreatedShow?'radio-disable':loading?'radio-disable':'radio',]"
                   @click="radioChecked(index,$event)"></div>
              <div class="radio-content">{{shareItem.name}}</div>
            </div>
            <div class="content-tips" >{{shareItem.tips}}</div>
            <transition name="fade" v-if="false">
              <div class="content-input-area" v-if="index===clickCurrent && clickCurrent===0">
                <input class="email-input" type="text" v-model="communityTitle" maxlength='128' placeholder='Title(Optional)'>
                <div class="text-area">
                  <textarea v-model="communityDes" maxlength='256' placeholder='Description(Optional)'></textarea>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <!--<div class="invite" :class="[inviteEmailShow?'invite-email':'']">
          <div class="invite-click" @click="letInviteEmailShow">
            {{$t('language.popup.cloudExploerPopup.inviteByEmail')}}
            <div class="icon-util folding-panel-position" :class="foldingPanel"></div>
          </div>
          <transition name="fade">
            <div v-if="inviteEmailShow" id="invite">
              <input class="email-input" :placeholder="$t('language.popup.cloudExploerPopup.pleaseEnterEmail')"
                     v-model="email"/>
              <div class="text-area">
                <textarea :placeholder="$t('language.popup.cloudExploerPopup.addMessage')"
                          v-model="emailMessage"></textarea>
              </div>
            </div>
          </transition>
        </div> -->
        <div class="all-copy" v-if="linkCreatedShow" >
          <div class="copy-button">
            <div class="icon-util share-link share-link-position share-icon"></div>
            <input class="site-input" v-model="linkUrl" readonly id="linkInput"/>
            <button class="site-copy" @click="copySite">{{$t('language.common.copy')}}</button>
          </div>
          <div class="verification-code">
            <input class="verification" v-model="sharePassword" readonly v-if="sharePassword"/>
            <div class="redit-back">
              <span @click="reEdit">{{$t('language.popup.redit')}}</span>
            </div>
          </div>
          <div class="all-sns" >
            <div style="float:left;height:30px;line-height:30px">{{$t('language.popup.cloudExploerPopup.shareTo')}}:
            </div>
            <div class="sns-icon email sns-icon-position" :title="$t('language.popup.cloudExploerPopup.shareOnEmail')" @click="letInviteEmailShow"></div>
            <div class="sns-icon facebook sns-icon-position" :title="$t('language.popup.cloudExploerPopup.shareOnFacebook')" @click="share($event)"></div>
            <div class="sns-icon twitter sns-icon-position" :title="$t('language.popup.cloudExploerPopup.shareOnTwitter')" @click="share($event)"></div>
            <div class="sns-icon tumblr sns-icon-position" :title="$t('language.popup.cloudExploerPopup.shareOnTumblr')" @click="share($event)"></div>
            <div class="sns-icon pinterest sns-icon-position" :title="$t('language.popup.cloudExploerPopup.shareOnPinterest')" @click="share($event)"></div>
            <div class="sns-icon ins sns-icon-position" :title="$t('language.popup.cloudExploerPopup.shareOnLinkedIn')" @click="share($event)"></div>
          </div>
        </div>
        <div class="create-share" v-if="!linkCreatedShow" :style="clickCurrent===3?'margin-top: 40px;':'margin-top: 26px;'">
          <div class="icon-util share-link share-link-position"></div>
          <div class="link-created">{{$t('language.popup.cloudExploerPopup.noLink')}}</div>
          <button class="share-button" @click="linkCreated($event)" v-loading="loading" >
            {{$t('language.popup.cloudExploerPopup.createShare')}}
          </button>
        </div>
      </div>
      <!-- 分享邮件页面 2020/8/7-xth -->
      <div class="share-content" id="shareMailContent" v-if="inviteEmailShow" :style="loadingEmail?'pointer-events: none;':''">
        <div class="share-button-left" @click="letInviteEmailShow" v-if="!isTransfer">
          <div class="icon-util arrow-left-blue"></div>
          <span style="vertical-align: super;">{{$t('language.cloudExploer.back')}}</span>
        </div>
        <div class="share-email-title" >{{$t('language.popup.cloudExploerPopup.shareEmailTitle')}}</div>
        <div class="invite">
            <div id="invite" ref="invite">
              <tags-input v-model='email' :message="$t('language.popup.cloudExploerPopup.pleaseEnterEmail')" :type="'email'" />
              <p class="err tips-info" v-if="isTransfer">{{tipsMsg.emails}}</p>
              <div class="text-area">
                <textarea :placeholder="$t('language.popup.cloudExploerPopup.addMessage')"
                          v-model="emailMessage" maxlength="1000"></textarea>
              </div>
              <button class="share-button" @click="shareSendEmail()" v-loading="loadingEmail" :style="(isTransfer&&tipsMsg.emails)?'margin-top: 0.1rem!important;':''">
                  {{$t('language.popup.cloudExploerPopup.shareSendEmail')}}
              </button>
            </div>
        </div>
      </div>
      <!-- 不支持源分享提示弹窗 2020/8/10-xth 暂不使用-->
      <!-- <div class="share-content" id="notSupportSourceContent" v-if="notSupportSourceShow" >
        <div class="share-item" >{{$t('language.popup.cloudExploerPopup.shareNotSupportSource')}}</div>
        <button class="share-button" @click="letNotSupportSourceShow()">
            {{$t('language.common.ok')}}
          </button>
      </div> -->
    </div>
    
  </div>
</template>

<script>
  import commonstate from '@/js/constant.js';
  import tagsInput from '@/components/common/input/tag_input';
  
  const BASE_URL = commonstate.sharePageUrl;

  export default {
    props: ['isTransfer'],//是否是分享传输页面打开的
    components: {
      tagsInput
    },
    data: function () {
      return {
        shareShow: false,
        sharetypes: [
          {
            name: "",
            tips: ""
          },
          {
            name: this.$t('language.popup.publicShare'),
            tips: this.$t('language.popup.publicTip')
          },
          {
            name: this.$t('language.popup.privateShare'),
            tips: this.$t('language.popup.privateTip')
          },
          {
            name: this.$t('language.popup.sourceShare'),
            tips: this.$t('language.popup.sourceTip')
          }
        ],
        clickCurrent: 1,
        inviteEmailShow: false,
        foldingPanel: "folding-panel",
        linkCreatedShow: false,
        fileInfo: '',
        linkUrl: '',
        communityDes: "",
        communityTitle: "",
        email: [],
        emailMessage: "",
        sharePassword: "",
        shareId: "",
        //2020/8/7-xth 是否进入编辑界面
        reEditCreated: false,
        //2020/8/10-xth 是否进入不支持源分享界面
        //notSupportSourceShow: false,
        loading: false,
        loadingEmail: false,
        pathJson: [],
        sourceClouds:[{"type":"google_drive","id":""},//可以源分享的云盘（googlePhotos只有Albums文件夹下才行）
          {"type":"oneDrive","id":""},
          {"type":"dropbox","id":""},
          {"type":"googlePhotos","id":""},
          {"type":"gSuite","id":""},
          {"type":"box","id":""},
          {"type":"pCloud","id":""},
          {"type":"oneDrive4Business","id":""},
          {"type":"dropbox4Business","id":""},
          {"type":"sharePointOnline","id":""},
          ],
        judgeSourceCloud: false,
        shareOriginalType: 1,//保存分享原始类型，原始类型和选中类型相同时，不进行更新
        emailHeight:"",//邮箱弹窗高度
        tipsMsg: {
          emails: "",//邮箱报错提示，shareTransfer用
        }
      };
    },
    watch: {
      //自适应邮箱弹窗高度
      email(val){
        this.$nextTick(function(){
          if(this.$refs.invite){}else{return}
          let inviteHeight = this.$refs.invite.clientHeight
          if(this.tipsMsg.emails){
            //如果有tips则需要扣去20
            inviteHeight -= 20;
          }
          if(inviteHeight<210){
            this.emailHeight = '380px !important';
          }else if(inviteHeight>210&&inviteHeight<240){
            this.emailHeight = '415px !important';
          }
          else if(inviteHeight>240){
            this.emailHeight = '435px !important';
          }
          this.tipsMsg.emails = "";//重置报错信息
        })
      }
    },
    created() {
      this.getSourceCloudsId()
    },
    computed: {
      classesOfDialog() {
        return {
          'share-link-content': this.linkCreatedShow && !this.inviteEmailShow && this.judgeSourceCloud,
          'share-link-content-noSource': this.linkCreatedShow && this.clickCurrent !== 0 && !this.inviteEmailShow && !this.judgeSourceCloud,
          'share-email': this.inviteEmailShow,
          'share-noSource': !this.linkCreatedShow && !this.inviteEmailShow && !this.judgeSourceCloud
        }
      }
    },
    methods: {
      share(e) {
        let classList = e.target.classList
        let shareUrl
        let shareText
        //mc的logo静态地址
        let sharePic = encodeURIComponent(`${commonstate.nowNewUrl}/static/mc-logo.png`);
        
        if(this.clickCurrent === 3){
          shareUrl = this.linkUrl;
        }else{
          shareUrl = encodeURIComponent(`${commonstate.sharePageApiUrl}/share/${this.shareId}`);
        }
        if(this.clickCurrent === 2){
          shareText = encodeURIComponent(this.fileInfo.name+this.$t('language.share.privateShareText'));
        }else{
          shareText = encodeURIComponent(this.fileInfo.name);
        }
        let url
        if (classList.contains("facebook")) {
          url = `https://www.facebook.com/dialog/share?app_id=1181798628562318&href=${shareUrl}&title=${shareText}`
        } else if (classList.contains("twitter")) {
          url = `https://twitter.com/share?url=${shareUrl}&text=${shareText}&via=multcloud`
        } else if (classList.contains("tumblr")) {
          url = `https://www.tumblr.com/widgets/share/tool?shareSource=legacy&canonicalUrl=&url=${shareUrl}&title=${shareText}`
        } else if (classList.contains("ins")) {
          url = `https://www.linkedin.com/shareArticle/?mini=true&title=${shareText}&url=${shareUrl}`
        } else {
          url = `https://www.pinterest.com/pin/create/button/?url=${shareUrl}&description=${shareText}&media=${sharePic}`
        }
        window.open(url, 'top')
      },
      radioChecked(index, event) {
        this.clickCurrent = index;
      },
      letInviteEmailShow() {
        this.inviteEmailShow = !this.inviteEmailShow;
        this.foldingPanel = this.inviteEmailShow ? "folding-panel-up" : "folding-panel"
      },
      linkCreated() {
        if(this.loading){
          return;
        }
        //判断用户是否选则分享方式(1-3之间)
        if (this.clickCurrent > 0 && this.clickCurrent < 4) {
          //更新时，如果原始类型于选中类型相同，退出编辑模式
          if(this.reEditCreated && this.clickCurrent == this.shareOriginalType){
            this.linkCreatedShow = true;
            this.reEditCreated = false;
            return;
          }
          this.loading = true;
          //获取分享文件根目录路径
          let pathJson = localStorage.getItem("path")?JSON.parse(Base64.decode(localStorage.getItem("path")))[this.fileInfo.pid + this.fileInfo.driveId]:"";
          //判断是否是已分享
          if(this.reEditCreated){
            //更新
            this.updateShare(pathJson)
          }else {
            //创建
            this.createdShare(pathJson)
          }
        }
      },
      //创建分享
      createdShare(pathJson) {
        let shareData = {
          ud: commonstate.user.id,
          pid: this.fileInfo.pid,
          n: this.fileInfo.name,
          fileId: this.fileInfo.id,
          fileType: this.fileInfo.dir ? "folder" : "file",
          fileSize: this.fileInfo.size,           
          shareId: this.shareId,
          shareType: this.clickCurrent + 1,
          tokenId: this.fileInfo.driveId,
          dir: this.fileInfo.dir,
          pathJson: pathJson
        }
        if(this.fileInfo.cloud){
          shareData.cloudId = parseInt(this.fileInfo.cloud.categoryInfo.id);
        }else{
          shareData.cloudId = parseInt(this.fileInfo.cloudType);
        }
        
        //保存创建人名称
        if(shareData.pathJson){
          shareData.pathJson.username = commonstate.user.username;
        }else{
          shareData.pathJson = {"username":commonstate.user.username};
        }
        //判断是否是源分享
        if(this.clickCurrent === 3){
          //源分享创建url后创建分享
          this.createdShareLinkSource(shareData,this.createdShareLink)
        }else{
          shareData.url = `${BASE_URL}${this.shareId}`,
          this.createdShareLink(shareData)
        }
      },
      //源分享创建url
      createdShareLinkSource(shareData,callBack) {
        if(this.judgeSourceCloud){
          //获取url
          this.Utils.doFilesRequest("share", {
            ud: commonstate.user.id,
            dd: this.fileInfo.driveId,
            id: this.fileInfo.id,
            dir: this.fileInfo.dir
          }).then(res => {
            if (res.url) {
              shareData.url = res.url;
              callBack(shareData);
            }else if(this.$route.query.cloudType == 'sharePointOnline' && res.reason == 'accessDenied'){
                  this.$toast({
                    text: this.$t('language.exception.'+res.reason),  
                    type: "fail",
                    idValue: "share"
                  });
                this.loading = false;
              }else{
              this.$toast({
                text: this.$t('language.popup.cloudExploerPopup.ceateShareError'),  
                type: "notice",
                idValue: "share"
              });
              this.loading = false;
            }
          })
        }else{
          this.$toast({
            text: this.$t('language.popup.cloudExploerPopup.ceateShareError'),
            type: "notice",
            idValue: "share"
          });
          this.loading = false;         
        }
      },
      //创建分享链接
      createdShareLink(shareData) {
        this.Utils.doShareRequest("create_share_url", shareData).then(response => {
          this.linkUrl = response.shareInfo.url;
          this.sharePassword = response.shareInfo.password || ""
          this.shareOriginalType = this.clickCurrent
          this.linkCreatedShow = true;
          if(response.shareInfo){
            this.$toast({
              text: this.$t('language.popup.cloudExploerPopup.generateLinkSuccess'),
              type: "success",
              idValue: "share"
            });
          }else{
            this.$toast({
              text: this.$t('language.popup.cloudExploerPopup.generateLinkFail'),
              type: "notice",
              idValue: "share"
            });
          }
          this.loading = false;
        })
      },
      //更新分享
      updateShare(pathJson) {
        let data = {
          shareId: this.shareId,
          shareType: this.clickCurrent + 1,
          pathJson: pathJson?pathJson:this.fileInfo.pathJson
        }
        //判断是否是源分享
        if(this.clickCurrent === 3){
          //源分享创建url后创建分享
          this.createdShareLinkSource(data,this.updateShareLink)
        }else{
          data.url = `${BASE_URL}${this.shareId}`,
          this.updateShareLink(data)
        }
      },
      //更新分享链接
      updateShareLink(data) {
        this.Utils.doShareRequest("update_share", data).then(res => {
          this.linkUrl = res.shareInfo.url;
          this.linkCreatedShow = true;
          this.sharePassword = res.shareInfo.password ? res.shareInfo.password : ""
          this.shareOriginalType = this.clickCurrent
          if(res.status === 200){
            this.$toast({
              text: this.$t('language.popup.cloudExploerPopup.generateLinkSuccess'),
              type: "success",
              idValue: "share"
            });
            //分享管理我的分享更新时，更新list
            if(this.$parent.myShare){
              this.$parent.updateShare(res.shareInfo);
            }
          }else{
            this.$toast({
              text: this.$t('language.popup.cloudExploerPopup.generateLinkFail'),
              type: "notice",
              idValue: "share"
            });
          }
          this.loading = false;
        })  
      },
      reEdit() {
        //修改只需要解除分享禁用，并标记进入修改状态
        this.linkCreatedShow = false;
        this.reEditCreated = true;
      },
      copySite() {
        let Url;
        if (this.clickCurrent === 2) {
          Url = document.createElement("input");
          Url.value = this.$t('language.popup.cloudExploerPopup.sharePrivateLink')+document.getElementById("linkInput").value
            +this.$t('language.popup.cloudExploerPopup.sharePrivatePassword')+this.sharePassword;
          document.body.appendChild(Url);
        }else{
          Url = document.getElementById("linkInput");
        }
        Url.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$toast({
          text: this.$t('language.popup.cloudExploerPopup.linkCopySuccessful'),
          type: "success",
          idValue: "share"
        });
      },
      closeDialog() {
        this.shareShow = false;
        this.clickCurrent = 1;
        this.linkCreatedShow = false;
        this.inviteEmailShow = false;
        this.communityTitle = '';
        this.communityDes = '';
        this.email = [];
        this.emailMessage = "";
        this.sharePassword = "";
        this.linkUrl = "";
        this.shareId = "";
        this.reEditCreated = false;
        //this.notSupportSourceShow = false;
        this.fileInfo = {};
        this.loadingEmail = false;
        this.loading = false;
        this.emailHeight = '380px !important';
        this.tipsMsg = {
          emails: "",//邮箱报错提示，shareTransfer用
        }
      },
      //初始化弹窗，查询是否已分享
      linkCreatedInit(dataShare) {
        if(dataShare){
          let shareInfo = dataShare
          this.linkCreatedShow = true
          this.clickCurrent = parseInt(shareInfo.type?shareInfo.type:0) - 1
          shareInfo.password ? this.sharePassword = shareInfo.password : ""
          this.linkUrl = shareInfo.url
          this.shareId = shareInfo.id
          this.shareShow = true;
          this.shareOriginalType = this.clickCurrent
        }else{
          // 生成分享链接之前判断是否生成过，并且获取shareId
          this.Utils.doShareRequest("check_share", {
            fileId: this.fileInfo.id,
            dd: this.fileInfo.driveId
          }).then(res => {
            if (res.message === "No share link generated!") {
              this.shareId = res.shareId;
            }else {
              // 已经生成过分享则后端返回分享数据，展示到sharedialog上
              let shareInfo = res.shareInfo
              this.linkCreatedShow = true
              this.clickCurrent = parseInt(shareInfo.type?shareInfo.type:0) - 1
              this.shareOriginalType = this.clickCurrent
              shareInfo.password ? this.sharePassword = shareInfo.password : ""
              this.linkUrl = shareInfo.url
              this.shareId = shareInfo.id

            }
            this.shareShow = true;
          })
        }
        //判断该地址是否能够源分享
        this.judgeSourceCloud = this.judgeSourceShareClouds(this.fileInfo.driveType);
      },
      // letNotSupportSourceShow() {
      //   this.notSupportSourceShow = !this.notSupportSourceShow;
      // },
      shareSendEmail() {
        if(this.loadingEmail){
          return;
        }
        if (this.email.length>0) {
          //邮箱验证
          //let regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          let regEmail =commonstate.emailpattern;
          let sendEmails = "";//可以发送的邮箱
          let errorEmails = [];//验证失败的邮箱
          this.email.forEach(function(e,index){
            if(regEmail.test(e.email.trim())){
              sendEmails += e.email+",";
            }else {
              e.status = 'error';
              errorEmails.push(e);
            }
          })
          if(sendEmails.length<1){
            if(this.isTransfer){
              this.tipsMsg.emails = this.$t('language.login.exception.emailError');
              return;
            }
            this.$toast({
              text: this.$t('language.popup.cloudExploerPopup.emailSentNotice'),
              type: "notice",
              idValue: "share"
            });
          }
          let shareEmail = {
            ud: commonstate.user.id,
            emailContent: this.emailMessage,
            //email: this.email,
            shareUrl: this.linkUrl,
            shareFileName: this.fileInfo.name,
            shareType: this.clickCurrent + 1,
            emails: sendEmails
          }
          // 私密分享则发送password
          this.clickCurrent === 2 ? shareEmail.passWord = this.sharePassword : ""
          this.loadingEmail = true;
          this.Utils.doEmailRequest("send_share_infos", shareEmail).then(res => {
            if (res.message === 'success'){
              if(this.isTransfer){
                this.$toast({
                  text: this.$t('language.popup.cloudExploerPopup.emailSentSuccessful'),
                  type: "success",
                  idValue: "share_transfer"
                });
                if(errorEmails.length>0){
                  this.tipsMsg.emails = this.$t('language.login.exception.emailError');
                }else{
                  this.closeDialog();
                }
              }else{
                this.$toast({
                  text: this.$t('language.popup.cloudExploerPopup.emailSentSuccessful'),
                  type: "success",
                  idValue: "share"
                });
              }
            }else{
              if(this.isTransfer){
                this.tipsMsg.emails = this.$t('language.popup.cloudExploerPopup.emailSentNotice');
              }else{
                this.$toast({
                  text: this.$t('language.popup.cloudExploerPopup.emailSentNotice'),
                  type: "notice",
                  idValue: "share"
                });
              }
            }
            //刷新当前收件人为为符合正则的邮箱，并且背景色变红
            if(errorEmails.length>0){
              this.email = errorEmails;
            }else{
              //全部发送则重置页面
              this.email = [];
              this.emailMessage = "";
            }
            this.loadingEmail = false;
          })
        }else {
          if(this.isTransfer){
            this.tipsMsg.emails = this.$t('language.popup.cloudExploerPopup.emailSentNull');
            return;
          }
          this.$toast({
            text: this.$t('language.popup.cloudExploerPopup.emailSentNull'),
              type: "notice",
              idValue: "share"
          });
        }
      },
      judgeSourceShareClouds(cloudId) {//判断该云盘是否是可以进行源分享的云盘
        let judge = false;
        let fileInfo = this.fileInfo;
        this.sourceClouds.forEach(function (item, index) {
          if(item.type===cloudId||item.id===(cloudId+"")){
            if("googlePhotos"===item.type){//googlePhotos还需要判断文件夹名
              if(fileInfo.pid&&fileInfo.pid==="/albums"){
                judge = true;
                return judge;
              }else{
                return judge;
              }
            }
            judge = true;
            return judge;
          }
        });
        return judge;
      },
      getSourceCloudsId() {
        //获取所有云盘资料,配置sourceClouds的id
        let that = this;
        //判断是否以获取云盘信息
        if(commonstate.cloudCategories.length==0){
          let clouds = this.Utils.getAllCloudsList(function (res) {
            if(res.categories&&res.categories.length>0){
              let allClouds = res.categories;
              let list = [];
              //筛选id
              allClouds.map((x) => {
                that.sourceClouds.map((k) => {
                  if (k.type == x.appName) {
                    return list.push({type:k.type,id:x.id});
                  }
                })
              })
              that.sourceClouds = list;
            }
          });
        }else{
          let allClouds = commonstate.cloudCategories
          let list = [];
          //筛选id
          allClouds.map((x) => {
          this.sourceClouds.map((k) => {
              if (k.type == x.appName) {
                return list.push({type:k.type,id:x.id});
              }
            })
          })
          this.sourceClouds = list;
        }
      }
    }
  };
</script>

<style scoped>
  .sns-icon-position {
    float: left;
    margin-left: 10px; /*no*/
    margin-right: 10px; /*no*/
  }

  .all-sns {
    margin-top: 8px;
    /*no*/
    margin-left: 28px;
    /*no*/
    overflow: hidden;
    /*no*/
    width: calc(100% - 28px);/*no*/
  }

  .redit-back {
    color: #4681f1;
    float: right;
    font-size: 14px;
    /*no*/
  }

  .verification {
    margin-left: 28px; /*no*/
    width: 100px;
    /*no*/
    float: left;
    height: 30px; /*no*/
    margin-top: 5px; /*no*/
  }

  .email-input {
    height: 30px; /*no*/
  }

  .all-copy {
    position: absolute;
    width: calc(100% - 40px);
    /*no*/
    height: 120px;
    /*no*/
  }

  .copy-button {
    width: 100%;
    height: 40px; /*no*/
    position: relative;
    margin-top: 15px;
  }

  .verification-code {
    width: 100%;
    height: 40px; /*no*/
    line-height: 50px; /*no*/
  }

  .site-copy {
    float: right;
    position: relative;
    top: 4px; /*no*/
  }

  .share-icon {
    float: left;
    position: relative;
    top: 11px; /*no*/
  }

  .site-input {
    width: 400px;
    /*no*/
    float: left;
    margin-top: 0 !important;
    height: 30px;
    /*no*/
    position: relative;
    top: 5px; /*no*/
    margin-left: 8px; /*no*/
  }

  .fade-enter-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .invite-click {
    width: 160px;
    /*no*/
    height: 25px;
    /*no*/
  }

  #share {
    width: 630px;
    /*no*/
    height: 250px;
    /*no*/
  }

  .share-community {
    height: 430px !important;
    /*no*/
  }

  .share-community-email {
    height: 320px !important;
  }

  .share-community-link {
    height: 470px !important;
  }

  .share-community-content {
    height: 200px !important;
    /*no*/
  }

  .share-email {
    height: 380px !important;
    /*no*/
  }

  /*.share-item-link {*/
  /*  height: 389px !important;*/
  /*  !*no*!*/
  /*}*/

  .share-link-content {
    height: 330px !important;
    /*no*/
  }

  .share-link-content-noSource {
    height: 285px !important;
    /*no*/
  }

  .share-noSource {
    height: 200px !important;
    /*no*/
  }

  .share-email-link {
    height: 539px !important;
    /*no*/
  }

  .share-community-email-link {
    height: 360px !important;
    /*no*/
  }

  .share-content {
    width: 100%;
    box-sizing: border-box;
    padding: 20px; /*no*/
    color: #6f7886;
    height: 91%; /*no*/
    overflow: auto;
  }

  /*.share-content-email {*/
  /*  height: 405px !important; !*no*!*/
  /*}*/

  /*.share-content-email-link {*/
  /*  height: 490px !important; !*no*!*/
  /*}*/

  /*.share-content-link {*/
  /*  height: 350px !important; !*no*!*/
  /*}*/

  .share-item {
    width: 100%;
    height: 22px; /*no*/
    margin-bottom: 1px; /*no*/
  }

  .share-item-checked {
    margin-bottom: 20px; /*no*/
  }

  .radio-position {
    position: absolute;
    top: 2px;/*no*/
    bottom: 0;
    margin: auto;
    float: left;
  }

  .radio-content {
    position: absolute;
    left: 25px; /*no*/
    font-size: 14px;
    /*no*/
  }

  .content-tips {
   
    height: 20px; /*no*/
    margin-left: 25px; /*no*/
    font-size: 12px;
    /*no*/
    line-height: 20px; /*no*/
  }

  .item-title {
    width: 100%;
    height: 20px; /*no*/
    line-height: 22px; /*no*/
    position: relative;
  }

  .invite {
    width: 100%;
    height: 63px; /*no*/
    color: #4681f1;
    line-height: 30px; /*no*/
    font-size: 14px;
    /*no*/
  }

  .invite-email {
    height: 200px !important; /*no*/
  }

  .invite-email-link {
    height: 289px !important; /*no*/
  }

  .invite-link {
    height: 148px !important; /*no*/
  }

  .folding-panel-position {
    position: relative;
    left: 3px; /*no*/
    top: 2px; /*no*/
  }

  .create-share {
    position: absolute;
    bottom: 15px;/*no*/
    width: calc(100% - 40px);/*no*/
    height: 30px; /*no*/
  }

  .share-link-position {
    float: left;
  }

  .link-created {
    float: left;
    font-size: 14px;
    /*no*/
    margin-left: 6px; /*no*/
  }

  .text-area {
    width: 100%;
    height: 100px; /*no*/
    margin-top: 10px; /*no*/
  }

  .text-area textarea {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #e0eaf9;
    /*no*/
    font-size: 14px;
    /*no*/
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    resize: none;
    color: #6f7886;
    padding-left: 10px; /*no*/
    padding-top: 7px; /*no*/
  }

  .text-area textarea::-webkit-input-placeholder {
    color: #ccc;
  }

  .text-area textarea:focus {
    border: 1px solid #8a96e3;
    /*no*/
    outline: none;
  }
  /*
   * 邮件页面新增css，2020/8/7-xth 
  */
  .share-email-title {
    text-align: center;
    margin-right: 60px;
    margin-bottom: 10px;
    font-weight: 800;
    font-size: 20px;
  }

  .share-button-left {
    margin-top: 5px;
    float: left;
    color: #4681f1;
  }

  .share-button-left:hover {
    cursor: pointer;
  }

  .share-forbidden {
    pointer-events: none;
    color: #D1D3D8;
  }

  .share-source {
    width: 550px !important;
    height: 180px !important;
    /*no*/
  }

  .share-source button {
    width: 100px !important;
    /*no*/
  }

  .share-email button {
    margin-top: 20px !important;
    width: 120px !important;
    /*no*/
  }

  .share-forbidden input{
    color: #D1D3D8;
  }

  .share-forbidden textarea{
    color: #D1D3D8;
  }

  .invite .text-area {
    height: 150px;
    /*no*/
  }

  .el-loading-spinner {
    margin-top : 0;
    font-size: 30px;
    /*no*/
  }

  #share .sns-icon-position:hover {
    cursor: pointer;
  }

  #share .redit-back:hover {
    cursor: pointer;
  }
  #share .radio:hover {
    cursor: pointer;
  }

#shareMailContent::-webkit-scrollbar,
.grid-list::-webkit-scrollbar,
.text-area textarea::-webkit-scrollbar {
  width: 8px;
  height: 0px;
  background-color: #fff;
  border-bottom: 0.5px solid #8A96E3;
}

#shareMailContent::-webkit-scrollbar-thumb,
.grid-list::-webkit-scrollbar-thumb,
.text-area textarea::-webkit-scrollbar-thumb {
  height: 1px;
  border-radius: 5px;
  background-color: #becae4;
}

#share .share-button .el-loading-mask {
    background-color: #5166BD;
    z-index: 0;
}

#share .share-button{
  float: right;
}

#share .tips-info.err {
  position: unset;
  line-height: 10px;/*no*/
  margin: 10px 0 0 10px;/*no*/
  font-size: 12px;/*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/share_popup.vue